import { useState } from "react";
import answeredSurveyService from "../../services/answered-survey-service";
import Button from '../bootstrap/Button';
import { showWarning } from "./Notifications";

interface Props {
    surveyId: string;
}

export const DownloadAnsweredSurveyReport = ({ surveyId }: Props) => {

    const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

    const handlePrintClick = async () => {

        setIsSubmitting(true);

        const response = await answeredSurveyService.getAnsweredSurveyReport(surveyId);
        
        setIsSubmitting(false);

        if (response.error) {
            showWarning(response.error);
            return;
        }

        const newWindow = window.open("", "_blank");
        if (!newWindow) return;

        newWindow.document.open();
        newWindow.document.write(response.answeredSurveyReport?.report || '');
        newWindow.document.close();

        // Aguarda o HTML carregar para chamar print
        newWindow.onload = () => {
            newWindow.focus();
            newWindow.print();
        };
    }

    return (
        <>
            <Button color="light" icon="Print" onClick={handlePrintClick}>
                Imprimir
            </Button>
        </>
    );
};